import React, {memo, useState,  useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from '../../models/stores/actions';
import {Swiper, SwiperSlide} from 'swiper/react';
import Morep from '../Morep';
import { isNormalZhEnCss, isMath } from '../../utils';
import  * as TYPES  from '../../models/types';

import 'swiper/css';
import styles from './styles.module.scss';

import SwiperCore, {
  Autoplay,Pagination,Navigation
} from 'swiper';


import arrowPreva from '../../assets/img/public/icons/arrowPreva.svg';
import arrowNexta from '../../assets/img/public/icons/arrowNexta.svg';


SwiperCore.use([Autoplay,Pagination,Navigation]);

const Index = memo((props) => {

  const dispatch = useDispatch();
  const {basicDrawerEvent} = actions;


  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  const [ activeIndex, setActiveIndex ] = useState(4);
  const [ liActiveKey, setLiActiveKey ] = useState(1001);
  const [swiperRef, setSwiperRef] = useState('');
  const intervalRef = useRef(0);


  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  };

  const swiperTemp = () => {
    const { data } = props.config;
    return (
        <Swiper
            initialSlide={activeIndex}
            className="dsSwiper"
            direction={'horizontal'}
            slidesPerView={'auto'}
            spaceBetween={0}
            loop={true}
            speed={1000}
            navigation = {{
              nextEl: '.btnPrevPage',
              prevEl: '.btnNextPage',
            }}
            onInit={(swiper) => {
              setSwiperRef(swiper);
              setActiveIndex(4);
            }}
            onSlideChange={(swiper) => {
              switch(swiper.activeIndex){
                case 5:
                  setInieLineTop(52);
                  setActiveIndex(5);
                  break;
                case 6:
                  setInieLineTop(110);
                  setActiveIndex(6);
                  break;
                case 7:
                  setInieLineTop(164);
                  setActiveIndex(7);
                  break;
                default:
                  setInieLineTop(0);
                  setActiveIndex(4);
                  break;
          
              }
             
              
            }}
        >
          {data.map(item => {
            return (
                <SwiperSlide key={item.id} onClick={() => handleClickShow(item)} style={{ height: 'auto' }}>
                  <div className="sInnerBox">
                    <img src={item.img} alt="" />
                    <div className="innerInfo">
                      <h5><span data-langkey="MHPTFTLNLT1002">{item.title}</span></h5>
                      <p><span data-langkey="MHPTFTLNLT100201">{item.subTitle}</span></p>
                    </div>
                  </div>
                </SwiperSlide>
            )
          })}
        </Swiper>
    )
  };
  
  const [inieLineTop, setInieLineTop] = useState(26);

  // 判断是：桌面/移动端
  const desktopMobile = () => {
    const { data } = props.config;
    return (
        <>
          <div className="left" ref={props.config.getRefs.leftRef} style={props.config.getRefs.leftStyles}>
            <div className="groupTop">
              <div className="groupLine">
                <div 
                  className="inieLine" 
                  style={{
                    top: isMath(recReSizeReducer, inieLineTop), 
                    transition: 'all .3s',
                    left: '50%',
                    marginLeft: isMath(recReSizeReducer, -3/2),
                  }}
                />
              </div>
              <div className="groupList">
                <ul>
                  {
                    data.map(item => {
                      return (<li onClick={() => handleGroupClick(item)} key={item.id} className={item.id === liActiveKey ? 'liActive ': null }><span>{item.title}</span></li>);
                    })
                  }
                </ul>
              </div>
            </div>
            <div className="groupFot">
              <Morep
                  config={{
                    status: true, // 是否显示 icon
                    isCursor: 1,
                    title: '',
                    style: {
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      alignItems: 'baseline',
                    },
                    iconCss: {
                      margin: '0 0 0 0',
                    }
                  }}
              />
            </div>
          </div>

          <div className="right" ref={props.config.getRefs.rightRef} style={props.config.getRefs.rightStyles}>
            <div className="switchLeftRight">
              <div className="btnNextPage" style={{cursor: 'pointer'}}><img src={activeIndex === 4 ? arrowPreva : arrowNexta} alt="" /></div>
              <div className="btnPrevPage" style={{cursor: 'pointer', transform: `rotate(180deg)`}}><img src={activeIndex === 7 ? arrowPreva : arrowNexta} alt="" /></div>
            </div>
            <div className="domesticSelectionSlides">
              {/*Swiper*/}
              {swiperTemp()}
            </div>
          </div>
        </>
    );
  };
  

  // TYPES.domesticTourType

  const handleClickShow = (item) => {
    dispatch(basicDrawerEvent({
      visible: TYPES.DRAWERSHOW,
      options: {
        type: TYPES.domesticTourType,
        doTour: TYPES.TRAVELMALL,
        index: item.index,
      },
    }));
  }

  const handleGroupClick = (item) => {
    setLiActiveKey(item.id);
    swiperRef.slideTo(item.num); 
    setActiveIndex(item.num);
    intervalRef.current = item.num;

    switch(item.num){
      case 5:
        setInieLineTop(52);
        break;
      case 6:
        setInieLineTop(110);
        break;
      case 7:
        setInieLineTop(164);
        break;
      default:
        setInieLineTop(0);
        break;
    }
  }


  return (
      <div className={normal()}>
        {desktopMobile()}
      </div>
  );
});
export default Index;
